import script from "./dempSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./dempSetup.vue?vue&type=script&setup=true&lang=js"

import "./dempSetup.vue?vue&type=style&index=0&id=3056de00&scoped=true&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3056de00"]])

export default __exports__